/**
 * Zag/Ark can leave stale modal side-effects on <body> (pointer-events, inert,
 * scroll lock). Safe when no Ark dialog is still open.
 */
export function clearStaleBodyOverlayStyles(): void {
  const stillOpen = document.querySelector(
    '[data-scope="dialog"][data-state="open"]',
  );
  if (stillOpen) return;

  const body = document.body;
  if (body.style.pointerEvents === "none") {
    body.style.pointerEvents = "";
  }
  if (body.hasAttribute("data-inert")) {
    body.removeAttribute("data-inert");
  }
  if (body.hasAttribute("data-scroll-lock")) {
    body.removeAttribute("data-scroll-lock");
  }
  if (body.style.overflow === "hidden") {
    body.style.removeProperty("overflow");
  }
  if (body.getAttribute("style") === "") {
    body.removeAttribute("style");
  }
}
